import { FunctionComponent } from "react";
import { Modal, ModalContent, ModalTitle } from "@ui-kit/Modal/Modal";

import "./LinkModal.css";

interface LinkModalProps {
  open: boolean;
  onClose: () => void;
  url: string;
  title: string;
}

const LinkModal: FunctionComponent<LinkModalProps> = ({
  open,
  onClose,
  url,
  title,
}) => {
  return (
    <Modal open={open} onClose={onClose} width={"90%"} zIndex={1200}>
      <ModalTitle fontSize="large">{title}</ModalTitle>
      <ModalContent>
        <div className="link-modal-iframe-container">
          <iframe
            src={url}
            width="100%"
            height={"100%"}
            frameBorder="0"
            title={title}
            className="link-modal-iframe"
          />
        </div>
      </ModalContent>
    </Modal>
  );
};

export { LinkModal, LinkModalProps };
